import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
import UserDetailsComp from "./component";
import { useParams } from "react-router-dom";

const UserBasicContainer = (props) => {
  const { userid } = useParams();
  
  const [details, setBasicDetails] = useState();
  const [loading, setLoading] = useState(true);
  const [employeeConfig, setEmployeeConfig] = useState({
    salaryType: "",
    salaryTypeId: "",
    vehicleType: "",
    vehicleTypeId: "",
    basicConfig: ""
  });
  const [salaryTypes, setSalaryTypes] = useState([]);
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [configLoading, setConfigLoading] = useState(false);
  const [warehouseId, setWarehouseId] = useState(null);

  useEffect(() => {
    LoadBasicDetails();
  }, []);

  useEffect(() => {
    // Fetch employee configuration once we have warehouseId from details
    if (warehouseId && userid) {
      fetchEmployeeConfiguration();
      fetchSalaryTypes();
      fetchVehicleTypes();
    }
  }, [warehouseId, userid]);

  const LoadBasicDetails = () => {
    return props.getDataFromAPI(
      `/dashboard/api/v2/admin/users/details?userId=${userid}`,
      "GET",
      undefined,
      (response) => {
        setLoading(false);
        setBasicDetails(response);
        
        // Extract warehouseId from response
        if (response?.warehouse?.id) {
          setWarehouseId(response.warehouse.id);
        }
        
        console.log("User details response:", response);
      },
      (err) => {
        setLoading(false);
        console.error("Error loading user details:", err);
      },
      true
    );
  };

  // Fetch employee configuration
  const fetchEmployeeConfiguration = () => {
    setConfigLoading(true);
    return props.getDataFromAPI(
      `/partner/api/v2/admin/df/${userid}/configuration?warehouseId=${warehouseId}`,
      "GET",
      undefined,
      (response) => {
        setConfigLoading(false);
        
        // Extract data from response structure
        const configData = response || response;
        
        // Get vehicle type name from ID if available
        let vehicleTypeName = configData?.vehicle?.vehicleType || "";
        let vehicleTypeId = configData?.vehicle?.vehicleTypeId || "";
        
        setEmployeeConfig({
          salaryType: configData?.salaryType || "",
          salaryTypeId: configData?.salaryTypeId || "",
          vehicleType: vehicleTypeName,
          vehicleTypeId: vehicleTypeId,
          basicConfig: configData?.basic?.activeBasic || configData?.basic?.warehouseDefault?.monthlyBasic || ""
        });
        
        console.log("Employee configuration:", configData);
      },
      (err) => {
        setConfigLoading(false);
        console.error("Error fetching employee configuration:", err);
      },
      true
    );
  };

  // Fetch salary types
  const fetchSalaryTypes = () => {
    return props.getDataFromAPI(
      `/partner/api/v2/admin/df/salary-types?warehouseId=${warehouseId}`,
      "GET",
      undefined,
      (response) => {
        // Extract salaryTypes array from response
        const salaryData = response?.salaryTypes || response?.salaryTypes || response || [];
        setSalaryTypes(Array.isArray(salaryData) ? salaryData : []);
        console.log("Salary types:", salaryData);
      },
      (err) => {
        console.error("Error fetching salary types:", err);
        setSalaryTypes([]);
      },
      true
    );
  };

  // Fetch vehicle types
  const fetchVehicleTypes = () => {
    return props.getDataFromAPI(
      `/partner/api/v2/admin/df/vehicle-types?warehouseId=${warehouseId}`,
      "GET",
      undefined,
      (response) => {
        // Extract vehicleTypes array from response
        const vehicleData = response?.vehicleTypes || response?.vehicleTypes || response || [];
        setVehicleTypes(Array.isArray(vehicleData) ? vehicleData : []);
        console.log("Vehicle types:", vehicleData);
      },
      (err) => {
        console.error("Error fetching vehicle types:", err);
        setVehicleTypes([]);
      },
      true
    );
  };

  // Save employee configuration with PATCH API
  const saveEmployeeConfiguration = (updatedConfig) => {
    setConfigLoading(true);
    
    // Format the data according to PATCH API expectations
    const payload = {};
    
    // Add monthly_basic if changed
    if (updatedConfig.basicConfig !== undefined && updatedConfig.basicConfig !== employeeConfig.basicConfig) {
      payload.monthly_basic = parseFloat(updatedConfig.basicConfig);
    }
    
    // Add vehicle_type_id if changed
    if (updatedConfig.vehicleTypeId !== undefined && updatedConfig.vehicleTypeId !== employeeConfig.vehicleTypeId) {
      payload.vehicle_type_id = parseInt(updatedConfig.vehicleTypeId);
    }
    
    // Add salary_type_id if changed
    if (updatedConfig.salaryTypeId !== undefined && updatedConfig.salaryTypeId !== employeeConfig.salaryTypeId) {
      payload.salary_type_id = parseInt(updatedConfig.salaryTypeId);
    }
    
    // Only make API call if there are changes
    if (Object.keys(payload).length === 0) {
      setConfigLoading(false);
      console.log("No changes to save");
      return;
    }
    
    return props.getDataFromAPI(
      `/partner/api/v2/admin/df/${userid}?warehouseId=${warehouseId}`,
      "PATCH",
      payload,
      (response) => {
        setConfigLoading(false);
        setEmployeeConfig(updatedConfig);
        console.log("Configuration saved successfully:", response);
      },
      (err) => {
        setConfigLoading(false);
        console.error("Error saving configuration:", err);
      },
      true
    );
  };

  // Handle field update
  const handleFieldUpdate = (field, value) => {
    let updatedConfig = { ...employeeConfig };
    
    switch(field) {
      case "salaryType":
        // Find the selected salary type object to get its ID
        const selectedSalaryType = salaryTypes.find(st => st.id === parseInt(value) || st.name === value);
        updatedConfig = {
          ...employeeConfig,
          salaryType: selectedSalaryType?.name || value,
          salaryTypeId: selectedSalaryType?.id || value
        };
        break;
      
      case "vehicleType":
        // Find the selected vehicle type object to get its ID and name
        const selectedVehicleType = vehicleTypes.find(vt => vt.id === parseInt(value) || vt.vehicleType === value);
        updatedConfig = {
          ...employeeConfig,
          vehicleType: selectedVehicleType?.vehicleType || value,
          vehicleTypeId: selectedVehicleType?.id || value
        };
        break;
      
      case "basicConfig":
        updatedConfig = {
          ...employeeConfig,
          basicConfig: value
        };
        break;
      
      default:
        updatedConfig = {
          ...employeeConfig,
          [field]: value
        };
    }
    
    setEmployeeConfig(updatedConfig);
    saveEmployeeConfiguration(updatedConfig);
  };

  return (
    <UserDetailsComp
      data={details}
      loading={loading}
      employeeConfig={employeeConfig}
      salaryTypes={salaryTypes}
      vehicleTypes={vehicleTypes}
      configLoading={configLoading}
      onFieldUpdate={handleFieldUpdate}
    />
  );
};

function mapStateToProps({ props }) {
  return {
    props,
  };
}

export default connect(mapStateToProps, {
  getDataFromAPI,
 
})(UserBasicContainer);